import * as React from 'react';

import { previewShouldShowCourseraPlusMerchandisingPlacements } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import ConsumerPageRootContent from 'bundles/unified-career-academy/pages/consumer/ConsumerPageRootContent';
import ConsumerPathwayCareerAcademyPageRootContent from 'bundles/unified-career-academy/pages/consumer/ConsumerPathwayCareerAcademyPageRootContent';
import ConsumerDataProvider from 'bundles/unified-career-academy/providers/ConsumerDataProvider';
import ConsumerPathwayCareerAcademyDataProvider from 'bundles/unified-career-academy/providers/ConsumerPathwayCareerAcademyDataProvider';
import CourseraPlusUpsellPlacementDataProvider from 'bundles/unified-common/providers/CourseraPlusUpsellPlacementDataProvider';
import { showPathwaysCareerAcademyPages } from 'bundles/unified-common/utils/showPathways';

const PathwaysCareerAcademyWrapper = () => {
  const showUpsells = previewShouldShowCourseraPlusMerchandisingPlacements();

  return (
    <ConsumerPathwayCareerAcademyDataProvider>
      <CourseraPlusUpsellPlacementDataProvider location="CAREER_ACADEMY" skipQuery={!showUpsells}>
        <ConsumerPathwayCareerAcademyPageRootContent />
      </CourseraPlusUpsellPlacementDataProvider>
    </ConsumerPathwayCareerAcademyDataProvider>
  );
};

const ConsumerPageRoot = () => {
  if (showPathwaysCareerAcademyPages()) {
    return <PathwaysCareerAcademyWrapper />;
  }

  return (
    <ConsumerDataProvider>
      <ConsumerPageRootContent />
    </ConsumerDataProvider>
  );
};

export default ConsumerPageRoot;
